var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('baseaktarim',{attrs:{"title":"ONUR AIR Bilet Aktarımı","status":_vm.status},on:{"submitfile":_vm.SubmitFile},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }